import { createFileRoute } from "@tanstack/react-router";
import { IssuesTable } from "#app/components/issues/issues-table";
import { useWorkflowId } from "#app/lib/hooks/use-workflow-id";

/** `/workflow/$workflowId/list` — the workflow issue list, scoped to one workflow. */
function WorkflowListRoute() {
  const workflowId = useWorkflowId();
  if (!workflowId) return null;
  return <IssuesTable scope={{ kind: "workflow", workflowId }} />;
}

export const Route = createFileRoute(
  "/(app)/$workspace/workflow/$workflowId/list",
)({
  component: WorkflowListRoute,
});
